import React from 'react';
import DataGridList from "../../../components/CommonList/DataGridList.js";

const Index = () => {

  const columns = [
    { name: 'Name', index: 'name', type: 'text' },
    { name: 'Hostname', index: 'hostname', type: 'text' },
    { name: 'Own API Key', index: 'has_api_key', type: 'bool' },
    { name: 'Enabled', index: 'is_active', type: 'input-switch' },
    { name: 'Last Modified', index: 'modified', type: 'date' }
  ];

  const options = {
    crud: true,
    add: {
      route: "/admin/amserver/form"
    },
    edit: {
      route: "/admin/amserver/form"
    },
    details: {
      route: ""
    },
    delete: {
      route: "amserver/"
    },
    enabledOpt: {
      url_edit: 'amserver/',
      field: null
    },
    export: {
      route: ""
    },
  }

  const url = "amservers"

  const filters = [];

  return (
      <DataGridList url={url} columns={columns} options={options} filters={filters}/>
  );
};

export default Index;
